// Connected-player list (UI, M27). Held-Tab reveals a roster overlay of everyone on
// the server (hue swatch + name), Minecraft-style. Only active in multiplayer; Tab is
// otherwise the chat command-completion key, so we ignore it while chat is open.
import { h } from '../h';
import type { Game } from '../../boot';
import type { NetSession } from '../../net/client';

export function installPlayerList(game: Game, net: NetSession): void {
  const panel = h('div', {
    style: {
      position: 'fixed', top: '8%', left: '50%', transform: 'translateX(-50%)',
      minWidth: '160px', padding: '8px 14px', borderRadius: '8px',
      background: 'rgba(10,14,22,0.82)', color: '#e6ebf5',
      font: '13px/1.7 ui-monospace, monospace', textAlign: 'center',
      zIndex: '45', pointerEvents: 'none', display: 'none',
    },
  });
  const title = h('div', { style: { fontWeight: '700', opacity: '0.8', marginBottom: '4px' } }, 'Players');
  const rows = h('div', {});
  panel.append(title, rows);
  document.body.append(panel);

  // §30.4: clicking your own row cycles your presence status.
  const STATUS_CYCLE = ['available', 'focus', 'call'] as const;

  const refresh = (): void => {
    rows.innerHTML = '';
    for (const p of net.players()) {
      const swatch = h('span', {
        style: {
          display: 'inline-block', width: '9px', height: '9px', marginRight: '7px',
          borderRadius: '2px', background: `hsl(${p.hue} 60% 55%)`, verticalAlign: 'middle',
        },
      });
      const own = p.id === net.welcome.playerId;
      // §29.8: a raised hand shows ✋ and its queue number beside the name.
      // §30.4: a non-default status shows as a word beside the name.
      const row = h('div', {
        'data-testid': `playerlist-${p.name}`,
        style: own ? { cursor: 'pointer', pointerEvents: 'auto' } : {},
      }, swatch, p.name,
        p.hand !== undefined ? ` ✋${p.hand}` : '',
        p.status && p.status !== 'available' ? ` (${p.status})` : '');
      if (own) {
        row.addEventListener('click', () => {
          const cur = p.status ?? 'available';
          const next = STATUS_CYCLE[(STATUS_CYCLE.indexOf(cur) + 1) % STATUS_CYCLE.length]!;
          game.cowStatus(next);
          refresh();
        });
      }
      rows.append(row);
    }
    if (net.players().length === 0) rows.append(h('div', { style: { opacity: '0.6' } }, '(only you)'));
  };

  document.addEventListener('keydown', (e) => {
    if (e.code !== 'Tab' || game.chatOpen || !game.locked) return;
    e.preventDefault();
    refresh();
    panel.style.display = 'block';
    panel.style.pointerEvents = 'auto';
  });
  document.addEventListener('keyup', (e) => {
    if (e.code === 'Tab') { panel.style.display = 'none'; panel.style.pointerEvents = 'none'; }
  });
}
